import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { ValidateRule } from "project-config/constants/validate-rule";
import request from "project-config/services/request/request";
const t = getTranslateNsT("center");

// validate email, phone
export async function remoteValidate(key: string, value: string) {
  const res = await request.post(`/api/rendering/user/validate/${key}`, {
    [key]: value,
    accountType: 2, // 1 主账号 2 子账号
  });
  if (res.code === 986) {
    return Promise.reject(t("utils_username_same_subaccount"));
  }
  if (res.code === 987) {
    return Promise.reject(t("utils_username_same_delete_subaccount"));
  }
  if (res.code === 990) {
    return Promise.reject(t("utils_username_same_sub_phone"));
  }
  if (res.code === 987) {
    return Promise.reject(t("utils_username_same_sub_email"));
  }
  if (res.code !== 200) {
    return Promise.reject(t(`utils_validate_${key}_exist`));
  }
}

export async function validateRule(rules: { r: boolean; message: string }[]) {
  const matchErrorRule = rules.find((item) => item.r);
  if (matchErrorRule) return Promise.reject(matchErrorRule.message);
}

export function useValidator() {
  const subUserNameValidator = async (
    args: any,
    allowEmpty?: boolean,
    shouldRemoteValidate?: boolean
  ) => {
    const [, value] = args;
    if (allowEmpty && !value) return Promise.resolve();
    const rules = [
      {
        r: value === "" || !value,
        message: t("utils_validate_username_empty"),
      },
      {
        r: !/^(?![0-9]+$)(?![_]+$)[0-9A-Za-z_]{6,20}$/.test(value),
        message: t("utils_validate_username_illegal"),
      },
    ];
    await validateRule(rules);
    shouldRemoteValidate && (await remoteValidate("userName", value));
    return Promise.resolve();
  };

  const passwordValidator = async (
    args: any,
    allowEmpty?: boolean,
    shouldRemoteValidate?: boolean
  ) => {
    const [, value] = args;
    if (allowEmpty && !value) return Promise.resolve();
    const rules = [
      {
        r: !value,
        message: t("utils_validate_psw_empty"),
      },
      {
        r: !(/^(?=.*[a-z])(?=.*[A-Z])[^]*$/.test(value) || value === ""),
        message: t("user_com_modify_label_psw_illegal"),
      },
      {
        r: !(/^(.*)?\d+(.*)?$/.test(value) || value === ""),
        message: t("user_com_modify_label_psw_illegal"),
      },
      {
        r: !(/^[^]{8,18}$/.test(value) || value === ""),
        message: t("user_com_modify_label_psw_illegal"),
      },
    ];
    await validateRule(rules);
    return Promise.resolve();
  };
  const phoneValidator = async (
    args: any,
    allowEmpty?: boolean,
    shouldRemoteValidate?: boolean,
    initValue?: string | number
  ) => {
    const [, value] = args;
    if ((allowEmpty && !value) || (initValue && initValue === value))
      return Promise.resolve();
    const rules = [
      { r: value === "", message: t("utils_validate_tel_empty") },
      {
        r: !/^1\d{10}$|(\(\d*\))(.+)/.test(value),
        message: t("utils_validate_tel_illegal"),
      },
    ];
    await validateRule(rules);
    shouldRemoteValidate && (await remoteValidate("phone", value));
    return Promise.resolve();
  };
  const emailValidator = async (
    args: any,
    allowEmpty?: boolean,
    shouldRemoteValidate?: boolean,
    initValue?: string | number
  ) => {
    const [, value] = args;
    if ((allowEmpty && !value) || (initValue && initValue === value))
      return Promise.resolve();
    const rules = [
      { r: value === "", message: t("utils_validate_email_empty") },
      {
        r: !ValidateRule.EMAIL.test(value.trim()),
        message: t("utils_validate_email_illegal3"),
      },
    ];
    await validateRule(rules);
    shouldRemoteValidate && (await remoteValidate("email", value.trim()));
    return Promise.resolve();
  };
  return {
    subUserNameValidator,
    passwordValidator,
    phoneValidator,
    emailValidator,
  };
}
